import ConfigurePage from './configure_page';
import MainPage      from './main_page';
import renderPage    from '../components/render_page';
import Tab           from '../settings/tab';


export default {
  path:         'data_sources',
  component:    renderPage(MainPage),
  name:         'DataSources',
  tabComponent: {
    component: Tab,
    name:      'settings'
  },
  routes: [
    {
      path:         ':name',
      name:         'DataSourcesConfigure',
      component:    renderPage(ConfigurePage),
      tabComponent: {
        component: Tab,
        name:      'settings'
      }
    }
  ]
};

